import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "columns" }
const _hoisted_2 = { class: "column is-4" }
const _hoisted_3 = { class: "column is-3" }
const _hoisted_4 = { class: "column" }
const _hoisted_5 = { class: "column" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pencil-alt" }, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-trash" }, null, -1)
const _hoisted_9 = [
  _hoisted_8
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CronometroComponent = _resolveComponent("CronometroComponent")!
  const _component_BoxComponent = _resolveComponent("BoxComponent")!

  return (_openBlock(), _createBlock(_component_BoxComponent, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.dados?.descricao || _ctx.$t('tarefa_sem_descricao')), 1),
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.dados?.projeto?.nome || 'N/D'), 1),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_CronometroComponent, {
            habilitarModoEscuro: false,
            "tempo-em-segundos": _ctx.dados?.duracaoEmSegundos
          }, null, 8, ["tempo-em-segundos"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("button", {
            class: "button",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.abrirModalEditarTarefa()))
          }, _hoisted_7),
          _createElementVNode("button", {
            class: "button ml-2 is-danger",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.removerTarefa && _ctx.removerTarefa(...args)))
          }, _hoisted_9)
        ])
      ])
    ]),
    _: 1
  }))
}